import { CORPUS_TOTAL } from "./corpus-counts.js";

/**
 * The public-facing library size, e.g. "14,700+".
 *
 * Derived from the auto-generated CORPUS_TOTAL (built from approved.json at
 * build time) and rounded DOWN to the nearest hundred, so the number on the
 * marketing site is always true and always conservative. Public copy used to
 * hardcode this, which is exactly how a claim goes stale.
 */
export const CORPUS_TOTAL_LABEL = `${(Math.floor(CORPUS_TOTAL / 100) * 100).toLocaleString("en-US")}+`;
